import { useState, type FormEvent } from "react";

const FORM_URL = "https://readdy.ai/api/form/daets0htto0ceqqnh3ug";

const promises = [
  { icon: "ri-file-list-3-line", title: "原创优先", desc: "每篇深度内容皆出自编辑部原创，拒绝搬运与洗稿。" },
  { icon: "ri-check-double-line", title: "核实为准", desc: "热点转发前先交叉求证，宁缺毋滥，不为流量失分寸。" },
  { icon: "ri-hand-heart-line", title: "友善氛围", desc: "倡导理性吃瓜，对事不对人，共建有分寸的讨论场。" },
];

export default function AboutContact() {
  const [submitting, setSubmitting] = useState(false);
  const [status, setStatus] = useState<"idle" | "success">("idle");
  const [error, setError] = useState("");

  async function handleSubscribe(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    const honey = (fd.get("website_alt") || "").toString().trim();
    const email = (fd.get("email") || "").toString().trim();

    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError("请填写正确的邮箱地址");
      return;
    }
    setError("");
    setStatus("idle");

    // 蜜罐命中：不向服务端提交，仅给出与正常一致的反馈
    if (honey) {
      setStatus("success");
      form.reset();
      return;
    }

    const payload = new URLSearchParams();
    payload.append("email", email);

    setSubmitting(true);
    try {
      const res = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg = parsed?.meta?.message || parsed?.meta?.detail || "";
      const ok = res.ok && parsed?.code === "OK";

      if (ok) {
        setStatus("success");
        form.reset();
      } else {
        setError(serverMsg && !/spam/i.test(serverMsg) ? serverMsg : "订阅失败，请稍后再试");
      }
    } catch {
      setError("网络异常，请稍后再试");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <section id="about" className="bg-background-100/70 py-14 md:py-20">
      <div className="wrap">
        <div className="text-center">
          <p className="mb-2 text-xs font-bold uppercase tracking-widest text-primary-600">ABOUT US</p>
          <h2 className="font-display text-2xl font-black text-foreground-950 md:text-4xl">关于吃瓜五一</h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm text-foreground-600">
            一个想把"吃瓜"这件事做好的原创内容门户——追得上一线热点，也守得住内容底线。
          </p>
        </div>

        <div className="mt-10 grid gap-8 lg:grid-cols-2">
          {/* 品牌介绍 */}
          <div className="flex flex-col gap-6">
            <div className="rounded-lg bg-background-50 p-6 md:p-7">
              <h3 className="font-display text-lg font-bold text-foreground-950">我们在做什么</h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700">
                吃瓜五一诞生于一群爱刷热点的年轻人对"好内容"的共同期待。我们不满足于只把瓜端到你面前，更想让你在围观之后能看懂来龙去脉。从娱乐八卦到社会议题，
                <span className="font-bold text-primary-700">编辑团队坚持原创写作、多方核实与客观呈现</span>
                ，努力让每一次刷新都有收获。
              </p>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700">
                这里没有博眼球的标题党，也没有无底线的煽动。我们相信，一个有温度、有判断力的内容社区，才能陪大家走得更远。
              </p>
            </div>

            <ul className="grid gap-4 sm:grid-cols-3">
              {promises.map((p) => (
                <li key={p.title} className="rounded-lg border border-background-200/70 bg-background-50 p-4">
                  <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-50">
                    <i className={`${p.icon} text-lg`}></i>
                  </span>
                  <h4 className="mt-3 text-sm font-bold text-foreground-900">{p.title}</h4>
                  <p className="mt-1 text-xs leading-relaxed text-foreground-600">{p.desc}</p>
                </li>
              ))}
            </ul>
          </div>

          {/* 订阅 + 联系 */}
          <div className="rounded-lg bg-primary-500 p-6 text-background-50 md:p-8" id="subscribe">
            <h3 className="font-display text-xl font-bold md:text-2xl">订阅每日热瓜早报</h3>
            <p className="mt-3 text-sm font-light leading-relaxed text-background-100">
              每天上午，把经过编辑部筛选的热点与新料打包送到你邮箱。轻量、干净、随时可退订，绝不打扰。
            </p>

            <form
              data-readdy-form="chigua-wuyi-newsletter"
              onSubmit={handleSubscribe}
              className="mt-6 space-y-3"
              noValidate
            >
              <div className="flex flex-col gap-3 sm:flex-row">
                <label className="sr-only" htmlFor="newsletter-email">
                  邮箱地址
                </label>
                <input
                  id="newsletter-email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  placeholder="name@example.com"
                  className="w-full rounded-md bg-background-50 px-4 py-3 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-accent-400"
                />
                <button
                  type="submit"
                  disabled={submitting}
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-bold text-foreground-950 transition hover:bg-accent-400 disabled:opacity-60"
                >
                  {submitting ? (
                    <>
                      <i className="ri-loader-4-line animate-spin"></i>提交中
                    </>
                  ) : (
                    <>
                      <i className="ri-mail-send-line"></i>立即订阅
                    </>
                  )}
                </button>
              </div>

              {/* 蜜罐字段：隐藏，防止机器人提交 */}
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="website_alt"
              />

              {status === "success" && (
                <p className="flex items-center gap-2 rounded-md bg-background-50/15 px-3 py-2 text-sm font-medium text-background-50">
                  <i className="ri-checkbox-circle-fill text-accent-300"></i>订阅成功，欢迎加入吃瓜大军！
                </p>
              )}
              {error && (
                <p role="alert" className="flex items-center gap-2 rounded-md bg-background-50/15 px-3 py-2 text-sm font-medium text-accent-100">
                  <i className="ri-error-warning-line"></i>{error}
                </p>
              )}
            </form>

            <div className="mt-7 grid grid-cols-1 gap-3 border-t border-background-50/25 pt-5 sm:grid-cols-2">
              <a href="mailto:hello@chiguawuyi.example" className="flex items-center gap-3 text-sm text-background-100 transition hover:text-background-50">
                <i className="ri-mail-line text-accent-300"></i>
                <span className="whitespace-nowrap">hello@chiguawuyi.example</span>
              </a>
              <a href="mailto:feedback@chiguawuyi.example" className="flex items-center gap-3 text-sm text-background-100 transition hover:text-background-50">
                <i className="ri-feedback-line text-accent-300"></i>
                <span className="whitespace-nowrap">feedback@chiguawuyi.example</span>
              </a>
              <div className="flex items-center gap-3 text-sm text-background-100">
                <i className="ri-time-line text-accent-300"></i>
                <span className="whitespace-nowrap">在线 09:00 - 24:00</span>
              </div>
              <div className="flex items-center gap-3 text-sm text-background-100">
                <i className="ri-global-line text-accent-300"></i>
                <span className="whitespace-nowrap">全网热点同步跟进</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}